export default __webpack_public_path__ + "static/media/image-finder1.2ca07440.png";